import { createPlugin } from '#pplx/frontend/composer-sdk/plugins/createPlugin.js';
/** Shares the no-prefix dropdown configuration while surfaces supply rows and selection behavior. */
export function createAutosuggestPlugin({ id, ...provider }) {
    return createPlugin({
        id,
        capabilities: [
            {
                kind: 'typeahead',
                providers: [
                    {
                        ...provider,
                        trigger: '',
                        display: 'suggestDropdown',
                        emptyMessage: null,
                    },
                ],
            },
        ],
    });
}
//# sourceMappingURL=createAutosuggestPlugin.js.map